import http from "./http";

const TONES = {
  SIMPLES: {tone: 'simples', icon: 'bi-file-earmark-text'},
  RET: {tone: 'retencao', icon: 'bi-file-earmark-lock'},
  RCE: {tone: 'especial', icon: 'bi-file-earmark-lock'},
  NRA: {tone: 'notificacao', icon: 'bi-file-earmark-medical'},
  NRB: {tone: 'notificacao', icon: 'bi-file-earmark-medical'},
  NRB2: {tone: 'notificacao', icon: 'bi-file-earmark-medical'},
  NRR: {tone: 'notificacao', icon: 'bi-file-earmark-medical'},
  NRT: {tone: 'notificacao', icon: 'bi-file-earmark-medical'},
};

const FALLBACK_TONE = {tone: 'simples', icon: 'bi-file-earmark-text'};

let types = [];
let request = null;

export function loadRegulatoryTypes() {
  if (types.length > 0) {
    return Promise.resolve(types);
  }

  if (!request) {
    request = http.get('/regulatory-types').then((response) => {
      types = response.data ?? [];
      return types;
    }).catch((e) => {
      request = null;
      throw e;
    });
  }

  return request;
}

export function regulatoryTypes() {
  return types;
}

export function regulatoryType(code) {
  return types.find((type) => type.code === code) ?? null;
}

export function regulatoryTypeName(code, fallback = null) {
  return regulatoryType(code)?.name ?? fallback;
}

export function regulatoryTypeShortName(code, fallback = null) {
  return regulatoryType(code)?.short_name ?? fallback;
}

export function requiresSncrNumber(code) {
  return regulatoryType(code)?.requires_sncr_number ?? false;
}

export function regulatoryBadge(classification) {
  if (!classification) {
    return null;
  }

  if (classification.status === 'BLOCKED') {
    return {
      label: 'VEDADO',
      title: 'Substância de uso proscrito no Brasil. A prescrição é vedada.',
      tone: 'vedado',
      icon: 'bi-slash-circle',
    };
  }

  if (classification.status === 'PENDING') {
    return {
      label: 'PENDENTE',
      title: classification.reason_description ?? 'Tipo de receituário ainda não definido.',
      tone: 'pendente',
      icon: 'bi-exclamation-triangle',
    };
  }

  const code = classification.regulatory_type;
  const tone = TONES[code] ?? FALLBACK_TONE;
  const name = regulatoryTypeName(code, classification.regulatory_type_description ?? code);

  return {
    label: regulatoryTypeShortName(code, code),
    title: classification.manual ? `${name} · escolhido manualmente pelo prescritor` : name,
    tone: tone.tone,
    icon: tone.icon,
    manual: classification.manual === true,
  };
}

export function classificationFromType(code) {
  return {
    status: 'CLASSIFIED',
    regulatory_type: code,
    regulatory_type_description: regulatoryTypeName(code, code),
    manual: false,
  };
}
